import {
    AlignmentType,
    Document,
    Paragraph,
    TabStopPosition,
    TabStopType,
    TextRun,
    ImageRun,
  } from "docx";
  
  export class DocumentCreator {
    create([certificate, fullList]) {
      const columnWidth = TabStopPosition.MAX / 2;
      const receiptTabStops = [
        { type: TabStopType.CENTER, position: columnWidth+300 },
        { type: TabStopType.RIGHT, position: TabStopPosition.MAX+600 },
      ];
  
      const arr = certificate.list;
      const newArr = [];
  
      arr.forEach((el) => {
        if (!newArr.includes(el.application.sportCategoryTitle)) {
          newArr.push(el.application.sportCategoryTitle);
        }
      });
      newArr.sort((a, b) => b.localeCompare(a, "ru"));
  
        const renderedCategories = new Set();
        const imageBase64 = 'data:image/png;base64,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'
        function base64ToArrayBuffer(base64) {
            let binaryString = atob(base64.split(',')[1]);
            let length = binaryString.length;
            let bytes = new Uint8Array(length);
            for (let i = 0; i < length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes.buffer;
        }
        const arrayBuffer = base64ToArrayBuffer(imageBase64);
  
      const document = new Document({
        sections: [
            {
            properties:{
                page: {
                    margin: {
                        top:'5mm',
                        left:'30mm',
                        right:'10mm',
                        bottom:'30mm',
                    },
                  },
            },
            children: [
                new Paragraph({
                    alignment: AlignmentType.CENTER, // Выравнивание по центру
                    children: [
                        new ImageRun({
                            data: arrayBuffer, // Используем ArrayBuffer
                            transformation: {
                                width: 54, // ширина изображения (в пикселях)
                                height: 74, // высота изображения (в пикселях)
                            },
                        }),
                    ],
                }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: {
                    before: 80,
                  },
                children: [
                  new TextRun({
                    text: "МІНІСТЕРСТВО МОЛОДІ ТА СПОРТУ УКРАЇНИ",
                    size: 32,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: {
                  after: 280,
                  before: 280,
                },
                children: [
                  new TextRun({
                    text: "Н А К А З",
                    size: 36,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                tabStops: receiptTabStops,
                children: [
                  new TextRun({
                    text: "від ____________ 20__р.\tКиїв\t№ __________",
                    size: 24,
                  }),
                ],
                spacing: {
                  before: 140,
                  after: 840,
                },
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                spacing: {
                  before: 840,
                },
                children: [
                  new TextRun({
                    text: "Про присвоєння спортивного звання",
                    size: 28,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                spacing: {
                  after: 840,
                },
                children: [
                  new TextRun({
                    text: '"Майстер спорту України"',
                    size: 28,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.BOTH,
                indent: {
                  firstLine: 600,
                },
                spacing: {
                  after: 280,
                },
                children: [
                  new TextRun({
                    text:
                      "Відповідно до вимог Положення про Єдину спортивну класифікацію України, затвердженого наказом Мінмолодьспорту від 07.12.2023 № 7512, зареєстрованого в Міністерстві юстиції України 25 грудня 2023 р. за\u00A0№\u00A02240/41296\u00A0(зі\u00A0змінами),",
                    size: 28,
                  }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                spacing: {
                  before: 280,
                  after: 280,
                },
                children: [
                  new TextRun({
                    text: "НАКАЗУЮ:",
                    size: 28,
                    bold: true,
                  }),
                ],
              }),
              ...newArr.map((el, index) => {
                if (renderedCategories.has(el)) {
                  return null;
                }
  
                renderedCategories.add(el);
  
                let res = "";
                switch (el) {
                  case "Неолімпійський":
                    res = "неолімпійських видів спорту";
                    break;
                  case "Олімпійський":
                    res = "олімпійських видів спорту";
                    break;
                  default:
                    res = "видів спорту осіб з інвалідністю";
                    break;
                }
  
                const athletesTitle =
                  certificate.list[0].application.athleteCategoryTitle.split(
                    "/"
                  )[0];
  
                return new Paragraph({
                  alignment: AlignmentType.JUSTIFIED,
                  indent: { firstLine: 600 },
                  spacing: {
                    after: 400,
                  },
                  children: [
                    new TextRun({
                      text: `${index + 1}. Присвоїти спортивне звання "${athletesTitle}" спортсменам з ${res} згідно зі списком ${
                        newArr.length === 1
                          ? ", що додається."
                          : `(додаток ${index + 1}).`
                      }`,
                      size: 28,
                    }),
                  ],
                });
              }),
              new Paragraph({
                alignment: AlignmentType.LEFT,
                spacing: {
                  before: 280,
                  after: 840,
                },
                indent: { firstLine: 600 },
                children: [
                  new TextRun({
                    text: `${newArr.length+1}. Контроль за виконанням цього наказу залишаю за собою.`,
                    size: 28,
                  }),
                ],
              }),
              new Paragraph({
                tabStops: receiptTabStops,
                size: 28,
                children: [
                  new TextRun({
                    text: `${certificate.list[0].signer1Position}\t\t${certificate.list[0].signer1Name}`,
                    size: 28,
                  }),
                ],
              }),
            ],
          },
        ],
      });
  
      return document;
    }
  }
  